import React from 'react';
import { HeadingLevelContext, DEFAULT_HEADING_LEVEL } from '../components/Heading';

function withAutoHeadingLevel() {
  return <T extends React.ComponentType>(Component: T): T => {
    const ComponentWithAutoHeadingLevel = props => {
      const level = React.useContext(HeadingLevelContext);
      return (
        <HeadingLevelContext.Provider value={level ? level + 1 : DEFAULT_HEADING_LEVEL}>
          <Component {...props} />
        </HeadingLevelContext.Provider>
      );
    };

    return ComponentWithAutoHeadingLevel as T;
  };
}

export default withAutoHeadingLevel;
